module.exports = __webpack_public_path__ + "img/login-poster.1bbc7646.jpeg";